import { Link } from "react-router-dom";
import { EyeIcon } from "../../components/Icons";
import { useState } from "react";
import { Button } from "react-bootstrap";

export const tableData = (data, setShowModal, setRow) => {
  const columns = [
    { field: "id", headerName: "ID", hide: true },
    {
      field: "created_at",
      headerName: "Fecha creación",
      minWidth: 175,
      flex: 1.3,
      renderCell: (params) => {
        const date = new Date(params.row.created_at);
        return <p className="mb-0">{date.toLocaleString()}</p>;
      },
    },
    {
      field: "updated_at",
      headerName: "Fecha Actualización",
      minWidth: 175,
      flex: 1.3,
      renderCell: (params) => {
        const date = new Date(params.row.updated_at);
        return <p className="mb-0">{date.toLocaleString()}</p>;
      },
    },
    // {
    //   field: "description",
    //   headerName: "Descripción",
    //   minWidth: 125,
    //   flex: 1,
    // },
    {
      field: "subject_type",
      headerName: "Subject Type",
      minWidth: 125,
      flex: 1.5,
    },
    {
      field: "event",
      headerName: "Event",
      minWidth: 125,
      flex: 1,
    },
    {
      field: "subject_id",
      headerName: "Subject Id",
      minWidth: 125,
      flex: 1,
    },
    {
      field: "causer_type",
      headerName: "Causer Type",
      minWidth: 125,
      flex: 1,
    },
    {
      field: "causer_id",
      headerName: "Causer Id",
      minWidth: 125,
      flex: 1,
    },
    {
      field: "properties",
      headerName: "Properties",
      minWidth: 125,
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Acciones",
      minWidth: 200,
      flex: 2,
      renderCell: (params) => {
        return (
          <>
            <div className="">
              <Link
                onClick={() => {
                  setRow(params.row);
                  setShowModal(true);
                }}
                style={{ textDecoration: "none" }}
              >
                <EyeIcon /> Ver
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const rows = data.map((d, index) => {
    return {
      id: d.id,
      created_at: d.created_at,
      updated_at: d.updated_at,
      description: d.description,
      subject_type: d.subject_type,
      event: d.event,
      subject_id: d.subject_id,
      causer_type: d.causer_type,
      causer_id: d.causer_id,
      properties: JSON.stringify(d.properties),
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
